import httpService from "../httpService";
import utils from "../utils";

export const vbOutgoingDocTdhvpViewService = {
  findAllVbBanHanh(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/vbOutgoingDocTdhvpView/findAllVbBanHanh", {
      params: params
    });
  },

  findById(id) {
    return httpService.get(`/vbOutgoingDocTdhvpView/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/tdhvp/vbOutgoingDocTdhvpViewService.js